// 同期対象の組織コード
export const ENABLE_SYNC_ORG_CODES = ['999']

// CSVダウンロード可能な組織コード
export const ENABLE_DOWNLOAD_CSV_ORG_CODES = ['007', '009', '013', '988', '999']

export const ENABLE_UPDATING_REGISTERED_STATUS = ['001', '004']

// NOTE: 006は古いOPA様向けorg_codeで011は正しいOPA様向けorg_code
// 006は先方社内で使うらしく、残している
// NOTE: 013(パルコ本番用)は Epic supsysjp/boba-server#3094 要件(5) で追加。
//       契約開始日を設定すると、その日より前の売上報告が app の「売上報告歴」から除外される
//       (boba-server の IsContractStarted。org分岐は無く全org共通の既存挙動)
export const VIEWABLE_CONTRACT_DATE_CODES = [
  '006',
  '007',
  '009',
  '011',
  '013',
  '988',
  '999',
]

// 契約形態やレジNo（OPA向けの項目）を利用する組織コード
// NOTE: 006は古いOPA様向けorg_codeで011は正しいOPA様向けorg_code
// 006は先方社内で使うらしく、残している
export const VIEWABLE_CONTRACT_TYPE_AND_REGISTER_ORG_CODES = [
  '006',
  '011',
  '985',
]

// OPCロール(editor_store_manager_in_operation_center)を権限プルダウンに出す組織コード
// NOTE: serverのトリガー check_role_and_organization_id() もOPC許可orgを別に持つ。
//       ここへorgを足すだけでは保存時にDB例外になるため、必ずセットでリリースする
export const ENABLE_ATTACH_EDITOR_STORE_MANAGER_IN_OPERATION_CENTER_ROLE = [
  '007',
  '011',
  '013',
  '985',
  '999',
]

// OPCロールを「施設担当者」と表示し、施設管理者・施設担当者を権限プルダウンから除く組織コード
// 除外しないと「施設担当者」が2つ並んで区別できないため、表示名の置換と選択肢の除外はセットで扱う
// NOTE: OPA(011/985)に加え、パルコ本番用org(013)が対象 (Issue supsysjp/boba-server#3529 要件(7))
export const DISPLAY_OPC_AS_EDITOR_STORE_MANAGER_ORG_CODES = [
  '011',
  '013',
  '985',
]

// Appへメッセージを送信できる組織コード
export const ENABLE_SEND_NOTIFICATION_ORG_CODES = [
  '007',
  '009',
  '013',
  '988',
  '999',
]

// 取引企業を利用する組織コード
export const ENABLE_TENANT_OWNER_COMPANY = ['999']

// 変更履歴を有効にする組織コード（server の activitylog.EnabledOrgCodes と対。両方に追加が必要）
// NOTE: 013(パルコ本番用)は要件(6) supsysjp/boba-admin#3627 で追加。
//       デモ用org(987)は対象外。
export const ENABLE_ACTIVITY_LOG_ORG_CODES = ['004', '011', '013']

// OCRハイライト機能を有効にする組織コード
export const ENABLE_OCR_HIGHLIGHT_ORG_CODES = ['009', '999']

// 変更履歴を有効にする組織コードかどうかを判定する
export const isActivityLogEnabled = (orgCode: string): boolean => {
  return ENABLE_ACTIVITY_LOG_ORG_CODES.includes(orgCode)
}

export const OPA_REGISTER_NUMBER_DIGIT = 3
export const OPA_DEPARTMENT_CODE_DIGIT = 3

// CSVのみダウンロード対象の組織コード（Excelなし）
// NOTE: この定数は「横持ち＋SCID必須＋ファイル名{scId}.csv」という009専用フォーマットに直結している。
//       単に「Excelを出さない」orgを増やす目的で追加してはいけない（パルコは PARCO_CSV_ORG_CODES を使う）
export const CSV_ONLY_DOWNLOAD_ORG_CODES = ['009']

// 確定前（報告済み・再送済み）のCSV出力を許可する組織コード
// パルコ本番用org(013): 確定前にディベロッパーへCSV連携し、その後に確定値を入力する運用 (Issue #3408)
//   出力後は「連携済み」になり、「確定済み」は出力対象外になる
// NOTE: この判定は算出項目マスタに依存しないため、単独で成立する（要件2）
export const PRE_FINALIZE_CSV_EXPORT_ORG_CODES = ['013']

// パルコ専用フォーマット（1テナント1行・ヘッダー有り・OCR値）でCSVを出力する組織コード (Issue #3408)
// パルコ本番用org(013)が対象。金額列の同定は domain/parcoCsv.ts の PARCO_CSV_ITEM_COLUMNS を参照する (#3454)
export const PARCO_CSV_ORG_CODES = ['013']

// 確定前（報告済み・再送済み）のCSV出力を許可する組織コードかどうかを判定する
export const isPreFinalizeCsvExportOrg = (orgCode: string): boolean => {
  return PRE_FINALIZE_CSV_EXPORT_ORG_CODES.includes(orgCode)
}

// パルコ専用フォーマットでCSVを出力する組織コードかどうかを判定する
export const isParcoCsvOrg = (orgCode: string): boolean => {
  return PARCO_CSV_ORG_CODES.includes(orgCode)
}

// 画面文言を「CSV」にするか「ZIP(CSV・Excel)」にするかの判定（ボタン・モーダルのラベル専用）。
// NOTE: CSVの出力フォーマット判定ではない。009専用フォーマット(横持ち+SCID)の分岐には
//       CSV_ONLY_DOWNLOAD_ORG_CODES を直接使うこと。ここに寄せるとパルコが009形式に流れる。
export const isCsvOnlyDownloadLabel = (orgCode: string): boolean => {
  return CSV_ONLY_DOWNLOAD_ORG_CODES.includes(orgCode) || isParcoCsvOrg(orgCode)
}

// 三井不動産商業マネジメント（orgCode: 007）で非表示にする算出項目名
// Issue #3409: 15項目から12項目に変更し、不要な項目を非表示にする
// この定数はDSL編集画面など、まだ非表示項目名方式（isHiddenCalculationItem）を使う箇所のために残している。
export const MITSUI_HIDDEN_CALCULATION_ITEM_NAMES = [
  '掛入金',
  '券余剰金',
  '電子マネー返金',
]

// 三井不動産商業マネジメント（orgCode: 007）の日次精査画面・売上報告タブ一覧で「表示する」項目の
// sendParameterName。appでテナントが手入力する3項目のみに絞る。
// send_parameter: 純売上=200, 客数=202, その他控除=107
// NOTE: 項目名（日本語）ではなく sendParameterName で識別する。DSL変更による表記ゆれに強い。
// NOTE: 値は CSV/Excel 出力対象（TARGET_SEND_PARAMS['007']）と一致するが、CSV出力と画面表示は
//       関心事が異なるため定数は分離して持つ。両者の一致は org.test.ts でアサートして担保する。
export const MITSUI_VISIBLE_SEND_PARAMS = ['200', '202', '107']

// 三井不動産商業マネジメントの組織コード
export const MITSUI_ORG_CODE = '007'

// 金額の桁数を11桁に拡張する組織コード（三井系: 007/988）
// NOTE: それ以外の組織は従来どおり9桁。サーバ側の検証（HasExtendedAmountDigits）と対象を揃える
// NOTE: '988' は金額桁数拡張のみが対象。他の三井系フラグ（MITSUI_HIDDEN_CALCULATION_ITEM_NAMES /
//       HIDE_READ_ITEM_TOGGLE_ORG_CODES 等）は '007' のみに適用するため、ここへの追加が他フラグへの適用を意味しない
export const EXTENDED_AMOUNT_DIGITS_ORG_CODES = ['007', '988']

// 金額の桁数を11桁に拡張する組織コードかどうかを判定する
export const hasExtendedAmountDigits = (orgCode: string): boolean => {
  return EXTENDED_AMOUNT_DIGITS_ORG_CODES.includes(orgCode)
}

// テナント売上確認画面の read_item トグルを非表示にする組織コード
export const HIDE_READ_ITEM_TOGGLE_ORG_CODES = ['007']

// テナント売上確認画面の read_item トグルを非表示にする組織コードかどうかを判定する
export const isReadItemToggleHidden = (orgCode: string): boolean => {
  return HIDE_READ_ITEM_TOGGLE_ORG_CODES.includes(orgCode)
}

// テナント売上確認画面で read_item プルダウンを初期状態で閉じる（全行）組織コード
// NOTE: 007 のトグル非表示(HIDE_READ_ITEM_TOGGLE_ORG_CODES)とは別物。
//       こちらはトグル操作・アイコンは残したまま、初期表示のみ全行閉じる（エラー行も展開しない）。
//       将来対象orgが増えたらこの配列に追加するだけで拡張できる。
export const COLLAPSE_READ_ITEM_INITIALLY_ORG_CODES = ['009']

// テナント売上確認画面で read_item プルダウンを初期状態で閉じる組織コードかどうかを判定する
export const isReadItemInitiallyCollapsed = (orgCode: string): boolean => {
  return COLLAPSE_READ_ITEM_INITIALLY_ORG_CODES.includes(orgCode)
}

// 完全一致フラグの判定結果を表示しない組織コード
// OPA(006/011): CCT連携値で精査するため突合結果を表示しない
// パルコ本番用org(013): 手入力スキップのため完全一致フラグが生成されない
// NOTE: 006は古いOPA様向けorg_codeで011は正しいOPA様向けorg_code
export const HIDE_CONSISTENCY_RESULT_ORG_CODES = ['006', '011', '013']

// 完全一致フラグの判定結果を表示しない組織コードかどうかを判定する
export const isConsistencyResultHidden = (orgCode: string): boolean => {
  return HIDE_CONSISTENCY_RESULT_ORG_CODES.includes(orgCode)
}

// 補足事項(テナントからのメモ)の添付画像を表示しない組織コード
// AEON(004): 追加改修要望により本機能の対象外
export const HIDE_MEMO_IMAGE_ORG_CODES = ['004']

// 補足事項の添付画像を表示しない組織コードかどうかを判定する
export const isMemoImageHidden = (orgCode: string): boolean => {
  return HIDE_MEMO_IMAGE_ORG_CODES.includes(orgCode)
}

// アプリに手入力ステップが無い組織コード（boba-server の HasNoManualInputStep と対）
// パルコ本番用org(013): 手入力値が常に無いため、精査画面の読取項目の初期値に OCR 値を使う (Issue #3687)
export const NO_MANUAL_INPUT_STEP_ORG_CODES = ['013']

// アプリに手入力ステップが無い組織コードかどうかを判定する
export const hasNoManualInputStep = (orgCode: string): boolean => {
  return NO_MANUAL_INPUT_STEP_ORG_CODES.includes(orgCode)
}

// 商談用の組織コード
export const ORG_999_CODE = '999'

// orgCode=999 で非表示にする算出項目名（12項目から4項目に変更）
export const ORG_999_HIDDEN_CALCULATION_ITEM_NAMES = [
  '現金売上',
  'クレジット売上',
  '電子マネー',
  'その他金券',
  '掛売上',
  '訪日割引額',
  '総取扱高（税込）',
  '消費税',
]
